//export const baseBackendUrl = "http://localhost:5000";
//export const baseFrontEndUrl = "http://localhost:3000";

export const baseBackendUrl = "https://codeak.ru/api";
export const baseFrontEndUrl = "https://codeak.ru";
